import './../sass/main.scss';
import $ from 'jquery';
import {tns} from 'tiny-slider/src/tiny-slider';

var map;
var fontsize = localStorage.getItem('fontsize', 1);
var fontsizes = [16, 16, 18, 21, 24];

$(function(){
    $('.js-hidefurther').each(function() {
        $('+ p', $(this)).addClass('content__dynamic');
        $('+ article p', $(this).parent()).addClass('content__dynamic');
    });

    $('.js-expandcontent').click(function(ev) {
        ev.preventDefault();
        let $container = $(this).parent().parent().parent();
        $('.content__dynamic', $container).addClass('content__dynamic--shown');
        $(this).parent().remove();
    });

    if($('.js-googlemaps').length) {
        $('.js-googlemaps').each(function() {
            let $map = $(this);
            let $markers = $('.map__marker', $map);

            map = new google.maps.Map($map[0], {
                zoom: $(this).data('zoom') || 16,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapId: '402a2c4bd9876fedcc1b0f4e'
            });

            map.markers = [];
            $markers.each(function() {
                let $marker = $(this);
                if(!$marker.data('lat') || !$marker.data('lng')) {
                    return;
                }

                let marker = new google.maps.marker.AdvancedMarkerElement({
                    position: {
                        lat: parseFloat($marker.data('lat')),
                        lng: parseFloat($marker.data('lng'))
                    },
                    map: map
                });
                map.markers.push(marker);

                if($marker.html()) {
                    let infoWindow = new google.maps.InfoWindow({
                        content: $marker.html()
                    });

                    google.maps.event.addListener(marker, 'click', function() {
                        infoWindow.open(map, marker);
                    });
                }
            });

            let bounds = new google.maps.LatLngBounds();
            map.markers.forEach(function(marker) {
                bounds.extend({
                    lat: marker.position.lat,
                    lng: marker.position.lng
                });
            });

            if(map.markers.length == 1) {
                map.setCenter(bounds.getCenter());
            } else {
                map.fitBounds(bounds);
            }

            /*
            if($('.js-mapsearch').length) {
                let autocomplete = new google.maps.places.Autocomplete($('.js-mapsearch')[0]);
                autocomplete.bindTo("bounds", map);
                autocomplete.addListener("place_changed", function() {
                    let place = autocomplete.getPlace();
                    if (!place.geometry || !place.geometry.location) {
                        return;
                    }

                    // Center the map
                    map.setCenter(place.geometry.location);
                    map.setZoom(12);

                    // Place a marker
                    marker.setPosition(place.geometry.location);
                    marker.setVisible(true);
                });
            }
            */
        });
    }

    $('[data-goup]').click(function(ev) {
        ev.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, 1000);
    });


    $('a[href="#"]').click(function(ev) {
        ev.preventDefault();
    });

    $('body').on('click', '.js-openmodal', function(ev) {
        ev.preventDefault();
        $('.modal[data-modal="' + $(this).attr('data-modal') + '"]').addClass('modal--shown');
    });

    $('.js-closemodal').click(function(ev) {
        ev.preventDefault();
        $('.modal--shown').removeClass('modal--shown');
    });

    $('.js-preventclose').click(function(ev) {
        ev.stopPropagation();
    });

    $('.sticker').addClass('sticker--shown');

    $('a[href="#test"]').each(function() {
        $(this).addClass('js-openmodal').attr('data-modal', 'thetest');
    });

    $(window).on('resize', function() {
        let toResize = '#sinefuma, .modal__inner';
        if($(document).width() < 768) {
            return $(toResize).css('transform', 'none');
        }
        $(toResize).css('transform', 'scale(' + ($(window).width() / 1920) + ')');
    }).trigger('resize');

    $('[data-href]').css('cursor','pointer').click(function() {
        let $link = $(this).find('a[href]');
        if($link) {
            let linkTarget = $link.attr('target');
            if(typeof linkTarget == 'undefined') {
                return window.location = $link.attr('href');
            }
            window.open($link.attr('href'), linkTarget).focus();
        }
    });

    var sliders = [];
    if($('.js-sineslider').length) {
        let sliderCounter = 0;
        $('.js-sineslider').each(function() {
            // Prepare for dynamic # of images
            let sliderCount = parseInt( $(this).attr("data-slides") );
            if(!sliderCount) {
                sliderCount = 3;
            }
            let itemsCount = window.innerWidth >= 768 ? sliderCount : 1;

            sliderCounter++;
            $(this).attr('id', 'sineslide' + sliderCounter);
            sliders.push(tns({
                autoplay:         true,
                center:           true,
                container:        '#' + $(this).attr('id'),
                controls:         true,
                controlsPosition: 'bottom',
                controlsText:     ['&larr;', '&rarr;'],
                items:            itemsCount,
                mouseDrag:        true,
                nav:              false,
                responsive: {
                    768: {
                        items: sliderCount,
                    }
                },
            }));
        });
    }

    if($('.js-sinefader').length) {
        let faderCounter = 0;
        $('.js-sinefader').each(function() {
            faderCounter++;
            $(this).attr('id', 'sinefade' + faderCounter);
            sliders.push(tns({
                autoplay:     true,
                center:       true,
                container:    '#' + $(this).attr('id'),
                controls:     false,
                controlsText: ["", ""],
                items:        1,
                mode:         'gallery',
                mouseDrag:    true,
                nav:          false,
            }));
        });
    }



    $('[data-search]').on('submit', function(ev) {
        ev.preventDefault();
        $.ajax({
            type: 'GET',
            url: wp_object.theme_url + '/xhr/' + $(this).attr('data-search') + '.php',
            data: $(this).serialize(),
            dataType: 'json',
            success: function(result) {
                let scrollTop = $('.js_results').offset().top;
                if($(document).width() < 768) { scrollTop -= 84; }
                $('.js_results').html(result.html);
                $('html, body').animate({scrollTop:scrollTop},1000);

                // Center the map
                map.setCenter({
                    lat: result.lat,
                    lng: result.lng
                });
                map.setZoom(12);
            },
            
            error: function(si,ne,fuma) {
                console.log(ne + ': ' + fuma);
            }
        });
    });

    $('[data-search] input[type="search"]').on('blur', function(ev) {
        if($(this).val().length > 0) {
            $(this).parent().trigger('submit');
        }
    });

    $('[data-more]').click(function(ev) {
        ev.preventDefault;
        $('#' + $(this).attr('data-more') + ' .b_news__hidden').removeClass('b_news__hidden');
        $(this).hide();
    });

    $('.js_togglemenu').click(function(ev) {
        ev.preventDefault();
        $('.menu--top').toggleClass('menu--open');
    });

    if(typeof fontsize == 'undefined' || !fontsize || isNaN(fontsize)) {
        fontsize = 1;
    }
    fontResize();

    $('[data-fontsize]').click(function(ev) {
        ev.preventDefault();
        fontsize = parseInt(fontsize) + parseInt($(this).attr('data-fontsize'));
        fontsize = Math.max(Math.min(fontsize, 4), 1);
        fontResize();
    });
});

function fontResize() {
    localStorage.setItem('fontsize', fontsize);
    $('body').removeClass('u-zoom1 u-zoom2 u-zoom3 u-zoom4 u-zoom5').addClass('u-zoom' + fontsize);
    $('html,body').css('font-size', fontsizes[fontsize]);
}

